import * as Views from '~/views/Remessa';

const basePath = '/remessas';

export default [
  { component: Views.RemessaList, path: basePath, exact: true },
];
